export default __webpack_public_path__ + "KaTeX_AMS-Regular.b1489df1556f8c6612594025ccdca2b0.woff";